import React, { Component } from 'react';
import BillCell from "./BillCell";
import {addBills, setEndReached, setRefund, startLoading} from "../store/bills/actions";
import { connect } from "react-redux";
import { getBills } from "../services/db";
import LoaderSpinner from "./LoaderSpinner";
import { Group, List } from '@vkontakte/vkui';
import {setModal} from "../store/globals/actions";
import ModalInfoCard from "./ModalInfoCard";
import {setModalInfo} from "../store/modal/actions";

class BillList extends Component {

    state = {
        listenerExist: true,
    };

    trackScrolling = () => {
        const wrappedElement = document.getElementById('bill-list');
        if (this.isBottom(wrappedElement) && !this.props.isBillsLoading) {
            this.loadItems();
        }
    };

    loadItems = async() => {
        this.props.dispatch(startLoading());

        const bills = await this.props.dispatch(getBills(this.props.cashierId, this.props.limit, this.props.offset));
        if (bills.result !== undefined && bills.result === 'success') {
            this.props.dispatch(addBills(bills.data.data.data));
            if (bills.data.data.data.length < this.props.limit) this.props.dispatch(setEndReached());
        } else {
            addBills([]);
        }
    };

    isBottom(el) {
        return el.getBoundingClientRect().bottom <= window.innerHeight;
    }

    componentDidMount() {
        document.addEventListener('scroll', this.trackScrolling);
    }

    componentWillUnmount() {
        document.removeEventListener('scroll', this.trackScrolling);
    }

    componentWillUpdate(nextProps, nextState) {
        if (!nextState.listenerExist && !nextProps.endReached) {
            document.addEventListener('scroll', this.trackScrolling);
            this.setState({ listenerExist: true });
        }
        if (nextState.listenerExist && nextProps.endReached) {
            document.removeEventListener('scroll', this.trackScrolling);
            this.setState({ listenerExist: false });

        }
    }

    openModal = (fio, paySum, payDate, refundSum, refundDate, allRefunds) => {
        this.props.dispatch(setModalInfo(fio, paySum, payDate, refundSum, refundDate, allRefunds));
        this.props.dispatch(setModal('modal-info'));
    };

    setRefund = (sum, transactionId, vkId) => {
        this.props.dispatch(setRefund(sum, transactionId, vkId));
    };

    renderList = () => {
        if (Object.keys(this.props.bills).length > 0) {
            return (
                <Group>
                    <List>
                        {
                            Object.keys(this.props.bills).map((key, i) => {
                                const bill = this.props.bills[key];
                                if (bill !== undefined) {
                                    return <BillCell
                                        id={ bill.id }
                                        fio={ bill.client_fio }
                                        vkId={ bill.client_vk_id }
                                        price={ bill.sum }
                                        refund={ bill.refund_sum }
                                        status={ bill.status }
                                        date={ bill.date }
                                        refundDate={ bill.date_refund }
                                        allRefunds={ bill.all_refunds }
                                        openModalFunc={ this.openModal }
                                        setRefundFunc={ this.setRefund }
                                        photo={ bill.client_photo }
                                        key={ 'bill-' + bill.id}
                                    />
                                }
                            })
                        }
                    </List>
                </Group>);
        } else {
            return '';
        }
    };

	render(){
		return(
			<div className="BillList" id="bill-list">
                { this.renderList() }
                { this.props.isBillsLoading && <LoaderSpinner/> }
			</div>
		)
	}
}

function mapStateToProps(state) {
    return {
        isBillsLoading: state.bills.isBillsLoading,
        bills: state.bills.bills,
        limit: state.bills.limit,
        offset: state.bills.offset,
        cashierId: state.cashier.cashier.cashier_id,
        endReached: state.bills.endReached,
    };
}

export default connect(mapStateToProps)(BillList);


// WEBPACK FOOTER //
// ./src/js/components/BillList.js